import React from 'react';
import { BotIcon, WorkflowIcon, TrendingUpIcon, MessageSquareIcon, CheckIcon } from 'lucide-react';
const capabilitiesData = [{
  icon: BotIcon,
  title: 'Intelligent Assistants That Learn Your Business',
  body: 'Deploy AI assistants that understand your domain, answer customer questions, and automate routine tasks. Our conversational AI solutions integrate with your existing systems and improve over time through machine learning.',
  capabilities: ['Custom-trained AI assistants for your industry', 'Natural language understanding and generation', 'Context-aware responses and recommendations', 'Integration with CRM, knowledge bases, and databases', 'Multi-channel deployment (web, mobile, Slack, Teams)']
}, {
  icon: WorkflowIcon,
  title: 'Automate Repetitive Work',
  body: 'Connect your tools and eliminate manual data entry with intelligent automation. We build custom workflows that trigger actions across your software stack, saving time and reducing errors.',
  capabilities: ['Custom automation workflows', 'API integrations between platforms', 'Data synchronization and transformation', 'Scheduled tasks and event-driven triggers', 'Error handling and notification systems']
}, {
  icon: TrendingUpIcon,
  title: 'Optimize with AI-Driven Analytics',
  body: "Leverage machine learning to improve your website's search rankings and user experience. Our AI tools analyze performance data, identify opportunities, and provide actionable recommendations.",
  capabilities: ['AI content optimization and keyword analysis', 'Automated performance monitoring', 'Predictive analytics for traffic and conversions', 'Competitor analysis and benchmarking', 'Personalized content recommendations']
}, {
  icon: MessageSquareIcon,
  title: 'Never Miss a Conversation',
  body: 'Engage website visitors around the clock with AI-powered chat that answers questions, qualifies leads, and escalates to your team when needed. Provide instant support without expanding headcount.',
  capabilities: ['Conversational AI trained on your content', 'Lead qualification and routing', 'Multi-language support', 'Seamless handoff to human agents', 'Analytics and conversation insights']
}];
export function AICapabilities() {
  return <section className="py-20" data-id="element-195">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
        {capabilitiesData.map(cap => {
        const Icon = cap.icon;
        return <div key={cap.title} className="mb-16 scroll-fade-in-up" data-id="element-197">
              <div className="flex items-start gap-4 mb-6" data-id="element-198">
                <div className="w-12 h-12 bg-surface rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-199">
                  <Icon className="w-6 h-6 text-primary" data-id="element-200" />
                </div>
                <div className="flex-1" data-id="element-201">
                  <h2 className="text-3xl font-bold text-ink mb-4" data-id="element-202">
                    {cap.title}
                  </h2>
                  <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-203">
                    {cap.body}
                  </p>
                  <div className="bg-surface rounded-xl p-6" data-id="element-204">
                    <h3 className="text-lg font-bold text-ink mb-4" data-id="element-205">
                      Capabilities:
                    </h3>
                    <ul className="space-y-3" data-id="element-206">
                      {cap.capabilities.map((capability, index) => <li key={index} className="flex items-start" data-id="element-207">
                          <CheckIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-208" />
                          <span className="text-gray-700" data-id="element-209">{capability}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>;
      })}
      </div>
    </section>;
}